<template>
  <div class="task-create">
    <el-card class="form-card">
      <div slot="header" class="card-header">
        <h2>创建任务</h2>
        <el-button icon="el-icon-arrow-left" @click="$router.back()">返回</el-button>
      </div>
      
      <el-form ref="taskForm" :model="taskForm" :rules="rules" label-width="100px">
        <el-form-item label="任务名称" prop="task_name">
          <el-input v-model="taskForm.task_name" placeholder="请输入任务名称" />
        </el-form-item>
        
        <el-form-item label="所属项目" prop="project_id">
          <el-select v-model="taskForm.project_id" placeholder="请选择项目" filterable style="width: 100%;">
            <el-option 
              v-for="project in projectOptions" 
              :key="project.project_id" 
              :label="project.name" 
              :value="project.project_id" 
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="任务描述" prop="description">
          <el-input type="textarea" v-model="taskForm.description" :rows="4" placeholder="请输入任务描述" />
        </el-form-item>
        
        <el-form-item label="优先级" prop="priority">
          <el-select v-model="taskForm.priority" placeholder="请选择优先级">
            <el-option label="低" :value="3" />
            <el-option label="中" :value="2" />
            <el-option label="高" :value="1" />
            <el-option label="紧急" :value="0" />
          </el-select>
        </el-form-item>
        
        <el-form-item label="截止日期" prop="finish_time">
          <el-date-picker v-model="taskForm.finish_time" type="datetime" placeholder="选择日期时间" style="width: 100%;" />
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSubmit" :loading="submitting">创建</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { createTask } from '@/api/task'
import { getMyProjectList } from '@/api/project'

export default {
  name: 'TaskCreate',
  data() {
    return {
      taskForm: {
        task_name: '',
        project_id: '',
        description: '',
        priority: 2,
        finish_time: ''
      },
      projectOptions: [],
      rules: {
        task_name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        project_id: [{ required: true, message: '请选择项目', trigger: 'change' }]
      },
      submitting: false
    }
  },
  mounted() {
    this.loadProjects()
  },
  methods: {
    async loadProjects() {
      try {
        const data = await getMyProjectList()
        if (data && data.list) {
          this.projectOptions = data.list
        } else if (Array.isArray(data)) {
          this.projectOptions = data
        }
      } catch (error) {
        console.error('加载项目列表失败:', error)
      }
    },
    async handleSubmit() {
      this.$refs.taskForm.validate(async (valid) => {
        if (!valid) return
        
        this.submitting = true
        try {
          // 转换字段格式以匹配后端 API
          const data = {
            task_name: this.taskForm.task_name,
            project_id: this.taskForm.project_id,
            description: this.taskForm.description,
            priority: this.taskForm.priority,
            finish_time: this.taskForm.finish_time ? new Date(this.taskForm.finish_time).toISOString() : null,
            task_type: 1  // 默认任务类型
          }
          await createTask(data)
          this.$message.success('任务创建成功')
          this.$router.push('/tasks')
        } catch (error) {
          this.$message.error('创建失败：' + (error.message || '未知错误'))
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.task-create {
  padding: 20px;
  background-color: var(--bg-page);
  min-height: calc(100vh - 84px);
}

.form-card {
  max-width: 800px;
  margin: 0 auto;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--text-primary);
  }
}
</style>
